import Vue from 'vue';
import Textarea from 'primevue/textarea';

Vue.component('Textarea', Textarea);
